import type { Pet } from "../core/pet";
import {
    ConsumeEffect,
    Effect,
    RoundEffect,
} from "../core/effect";

export type VisibleEffect =
    | {
          kind: "round";
          effect: RoundEffect;
          remaining: number;
          unit: "回合";
      }
    | {
          kind: "consume";
          effect: ConsumeEffect;
          remaining: number;
          unit: "次";
      }
    | {
          kind: "permanent";
          effect: Effect;
          remaining: null;
          unit: null;
      };

export function getVisibleEffects(pet: Pet): VisibleEffect[] {
    const permanentEffects = pet.常驻类效果.all().map(
        (effect): VisibleEffect => ({
            kind: "permanent",
            effect,
            remaining: null,
            unit: null,
        })
    );
    const consumeEffects = pet.消耗类效果.all()
        .filter((effect) => effect.remainTriggerNum > 0)
        .map(
            (effect): VisibleEffect => ({
                kind: "consume",
                effect,
                remaining: effect.remainTriggerNum,
                unit: "次",
            })
        );
    const roundEffects = pet.回合类效果.all()
        .filter((effect) => effect.remainRoundNum > 0)
        .map(
            (effect): VisibleEffect => ({
                kind: "round",
                effect,
                remaining: effect.remainRoundNum,
                unit: "回合",
            })
        );

    return [...permanentEffects, ...consumeEffects, ...roundEffects];
}

export function getEffectStyle(item: VisibleEffect): string {
    return item.kind;
}
